'use client';

/**
 * useResize React custom hook
 * Usage:
 *    const { isMobile, isTablet, isDesktop, windowWidth, windowHeight, windowOuterWidth, windowOuterHeight } = useResize();
 */
import { useState, useEffect } from 'react';

import { IS_BROWSER } from '@wconcept/wconcept-common/utils/baseUtils';

const TABLET = 601;
const DESKTOP = 1201;

const useResize = () => {
  const [size, setSize] = useState([0, 0]);
  const [outerSize, setOuterSize] = useState([0, 0]);
  const [isMobile, setIsMobile] = useState(
    IS_BROWSER
      ? window.screen.availWidth < TABLET && window.screen.availWidth !== 0
      : false
  );
  const [isTablet, setIsTablet] = useState(
    IS_BROWSER
      ? window.screen.availWidth >= TABLET &&
          window.screen.availWidth < DESKTOP &&
          window.screen.availWidth !== 0
      : false
  );
  const [isDesktop, setIsDekstop] = useState(
    IS_BROWSER
      ? window.screen.availWidth >= DESKTOP && window.screen.availWidth !== 0
      : false
  );
  useEffect(() => {
    function updateSize() {
      const { width } = document
        .getElementsByTagName('body')[0]
        .getBoundingClientRect();
      if (IS_BROWSER) {
        setSize([width, window.innerHeight]);
        setOuterSize([window.outerWidth, window.outerHeight]);
        setIsMobile(width < TABLET && width !== 0);
        setIsTablet(width >= TABLET && width < DESKTOP && width !== 0);
        setIsDekstop(width >= DESKTOP && width !== 0);
      }
    }
    if (IS_BROWSER) window.addEventListener('resize', updateSize);
    updateSize();
    return () => {
      if (IS_BROWSER) window.removeEventListener('resize', updateSize);
    };
  }, []);
  return {
    isMobile,
    isTablet,
    isDesktop,
    windowWidth: size[0],
    windowHeight: size[1],
    windowOuterWidth: outerSize[0],
    windowOuterHeight: outerSize[1],
  };
};

export default useResize;
